import { Fragment, ReactElement } from 'react';
import ResearchCitizenshipAnscNotificationsShared from 'shell/components/shared/ansc-notifications/research-citizenship';
import { CitizenshipAnscNotificationsMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchCitizenshipAnscNotificationsPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchCitizenshipAnscNotificationsShared
        scope={IdAmbito.Mutazioni}
        items={CitizenshipAnscNotificationsMutationCrumbs()}
      />
    </Fragment>
  );
};

ResearchCitizenshipAnscNotificationsPage.displayName =
  'Research Citizenship Notifications Page component';

export default ResearchCitizenshipAnscNotificationsPage;
